import { useContext } from 'react'
import { DocumentContext } from '../contexts/DocumentContext'

export const useDocument = () => {
  const context = useContext(DocumentContext)

  return context
}
